import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FootersModule } from '@app/blocks/footers/footers.module';

import { PoliticaPrivacidadRoutingModule } from './politica-privacidad-routing.module';
import { PoliticaPrivacidadContenidoComponent } from './components/politica-privacidad-contenido/politica-privacidad-contenido.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [PoliticaPrivacidadContenidoComponent],
  imports: [
    CommonModule,
    PoliticaPrivacidadRoutingModule,
    FootersModule,
    FontAwesomeModule
  ]
})
export class PoliticaPrivacidadModule {}
